import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import ThreatPanel from '../components/ThreatPanel';
const API = "https://tribaltech-backend.onrender.com";
{/* ThreatPanel disabled */}
function CSSidebar() {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("tribal_user") || "{}");
  const nav = [
    { path: "/dashboard", label: "Overview", icon: "◈" },
    { path: "/cs-upload", label: "Upload content", icon: "↑" },
    { path: "/cs-removals", label: "Removals", icon: "◉" },
    { path: "/tracker",  label: "Takedowns", icon: "⊟" },
    { path: "/settings", label: "Settings", icon: "⚙" },
  ];

  return (
    <div style={{ width: 220, minHeight: "100vh", background: "#0a0a10", borderRight: "0.5px solid rgba(255,255,255,0.07)", display: "flex", flexDirection: "column", padding: "24px 0", flexShrink: 0 }}>
      <div style={{ padding: "0 20px 24px", borderBottom: "0.5px solid rgba(255,255,255,0.07)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
          <div style={{ width: 24, height: 24, borderRadius: 5, background: "#0D9488", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 600, color: "#fff" }}>C</div>
          <span style={{ fontSize: 13, fontWeight: 500, color: "#f0ede8" }}>Creator Protect</span>
        </div>
        <div style={{ fontSize: 11, color: "#0D9488", fontWeight: 500, letterSpacing: "0.06em" }}>CLEAN SLATE</div>
      </div>

      <nav style={{ padding: "16px 12px", flex: 1 }}>
        {nav.map(n => (
          <Link key={n.path} to={n.path} style={{
            display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 8, fontSize: 13,
            color: location.pathname === n.path ? "#f0ede8" : "rgba(240,237,232,0.45)",
            background: location.pathname === n.path ? "rgba(13,148,136,0.12)" : "transparent",
            textDecoration: "none", marginBottom: 4, transition: "all 0.2s",
          }}>
            <span style={{ fontSize: 14, color: location.pathname === n.path ? "#0D9488" : "rgba(240,237,232,0.3)" }}>{n.icon}</span>
            {n.label}
          </Link>
        ))}
      </nav>

      <div style={{ padding: "16px 20px", borderTop: "0.5px solid rgba(255,255,255,0.07)" }}>
        <div style={{ fontSize: 12, color: "rgba(240,237,232,0.35)", marginBottom: 6 }}>{user.email}</div>
        <div style={{ fontSize: 12, color: "#0D9488", cursor: "pointer" }} onClick={() => { localStorage.clear(); window.location.href = "/login"; }}>Sign out</div>
      </div>
    </div>
  );
}

export default function CleanSlateDashboard() {
  const [stats, setStats] = useState({ files: 0, found: 0, removed: 0, nextScan: null, telegram_hits: 0 });
  const [removals, setRemovals] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("tribal_token");
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    const load = async () => {
      try {
        const [statsRes, leaksRes, telegramRes] = await Promise.allSettled([
          axios.get(`${API}/api/dashboard`, { headers }),
          axios.get(`${API}/api/leaks`, { headers }),
          axios.get(`${API}/api/leaks/telegram`, { headers }).catch(() => ({ data: [] })),
        ]);
        const statsData = statsRes.status === "fulfilled" ? statsRes.value : { data: {} };
        const leaksData = leaksRes.status === "fulfilled" ? leaksRes.value : { data: [] };
        const statsRes2 = statsData;
        const leaksRes2 = leaksData;
        const d = statsRes2.data || {};
        setStats({
          files: d.fingerprinted || d.protected || 0,
          found: Array.isArray(d.leaks) ? d.leaks.length : (d.leaks || 0),
          // 2026-11-02: fix mislabel — "removed" tile must come from
          // leak_detections.removed_at (surfaced by /api/dashboard as
          // stats.removed), not from the DMCAs-filed count. Prior
          // `d.dmca || 0` was both a field-name mismatch (field is
          // `stats.dmca_filed`, not `dmca`) and a semantic mislabel.
          removed: d.stats?.removed || 0,
          nextScan: "Next Monday",
        });
        setRemovals((leaksRes2.data || []).slice(0, 10).map(r => {
          let platform = r.platform || 'Unknown platform';
          if (!r.platform && r.leaked_url) {
            try { platform = new URL(r.leaked_url).hostname.replace('www.',''); } catch {}
          }
          // 2026-11-02: 3-state status, replacing the prior
          // `r.dmca_filed ? 'removed' : 'pending'` mislabel. Rule:
          //   'removed' only when removed_at IS NOT NULL
          //   'filed'   when dmca_filed=true and removed_at IS NULL
          //   'pending' otherwise
          // Once backfill_dmca_filed_from_targets_2026_11_02 lands,
          // dmca_filed=true also covers "has sent dmca_notice_targets".
          let status = 'pending';
          if (r.removed_at)      status = 'removed';
          else if (r.dmca_filed) status = 'filed';
          return {
            platform,
            url: r.leaked_url || r.url || 'URL not available',
            status,
          };
        }));
      } catch (e) {}
      setLoading(false);
    };
    load();
  }, []);

  const S = {
    page: { display: "flex", minHeight: "100vh", background: "#06060a", color: "#f0ede8", fontFamily: "'DM Sans', sans-serif" },
    main: { flex: 1, padding: "40px 48px", overflowY: "auto" },
    card: { background: "rgba(255,255,255,0.02)", border: "0.5px solid rgba(255,255,255,0.08)", borderRadius: 14, padding: "24px 28px" },
    statCard: { background: "rgba(13,148,136,0.06)", border: "0.5px solid rgba(13,148,136,0.15)", borderRadius: 12, padding: "20px 24px", textAlign: "center" },
  };

  return (
    <div style={S.page}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500&family=DM+Serif+Display:ital@0;1&display=swap'); *{box-sizing:border-box;margin:0;padding:0} a{text-decoration:none;color:inherit}`}</style>
      <CSSidebar />
      <main style={S.main}>

        {/* Header */}
        <div style={{ marginBottom: 40 }}>
          <div style={{ fontSize: 11, fontWeight: 500, color: "#0D9488", letterSpacing: "0.08em", marginBottom: 10 }}>CLEAN SLATE</div>
          <h1 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 32, fontWeight: 400, marginBottom: 8 }}>Your removal dashboard</h1>
          <p style={{ fontSize: 14, color: "rgba(240,237,232,0.5)", lineHeight: 1.6 }}>We're scanning the internet for your content every week and removing everything we find.</p>
        </div>

        {/* Stats */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginBottom: 40 }}>
          {[
            { num: loading ? "—" : String(stats.files || 0), label: "Files protected", color: "#0D9488" },
            { num: loading ? "—" : String(stats.found || 0), label: "Copies found", color: "#E24B4A" },
            { num: loading ? "—" : String(stats.removed || 0), label: "Copies removed", color: "#0D9488" },
            { num: loading ? "—" : String(stats.telegram_hits || 0), label: "Telegram hits", color: "#A78BFA" },
            { num: "Next Monday", label: "Next scan", color: "#7B5EA7" },
          ].map((s, i) => (
            <div key={i} style={S.statCard}>
              <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 28, fontWeight: 400, color: s.color, marginBottom: 6 }}>{s.num}</div>
              <div style={{ fontSize: 12, color: "rgba(240,237,232,0.45)", letterSpacing: "0.04em" }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Upload CTA if no files */}
        {!loading && stats.files === 0 && (
          <div style={{ ...S.card, textAlign: "center", padding: "48px 40px", marginBottom: 32, border: "0.5px solid rgba(13,148,136,0.2)" }}>
            <div style={{ fontSize: 32, color: "#0D9488", marginBottom: 16 }}>◈</div>
            <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 24, fontWeight: 400, marginBottom: 10 }}>Upload your first files to get started</h2>
            <p style={{ fontSize: 14, color: "rgba(240,237,232,0.5)", lineHeight: 1.7, maxWidth: 400, margin: "0 auto 28px" }}>
              Upload the videos and photos you want removed from the internet. We'll start scanning within 24 hours.
            </p>
            <Link to="/cs-upload" style={{ display: "inline-block", background: "#0D9488", color: "#fff", padding: "12px 28px", borderRadius: 8, fontSize: 14, fontWeight: 500 }}>
              Upload content now
            </Link>
          </div>
        )}

        {/* Recent removals */}
        {removals.length > 0 && (
          <div style={S.card}>
            <div style={{ fontSize: 11, fontWeight: 500, color: "rgba(240,237,232,0.4)", letterSpacing: "0.08em", marginBottom: 20 }}>RECENT REMOVALS</div>
            {removals.map((r, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 0", borderBottom: i < removals.length - 1 ? "0.5px solid rgba(255,255,255,0.06)" : "none" }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 3 }}>{r.platform || "Unknown platform"}</div>
                  <div style={{ fontSize: 12, color: "rgba(240,237,232,0.35)", wordBreak: "break-all" }}>{r.url || "URL not available"}</div>
                </div>
                <div style={(() => {
                  // 2026-11-02: 3-state badge palette. 'filed' gets
                  // its own amber style so a sent-notice row doesn't
                  // fall through to the red 'pending' palette.
                  const palette = {
                    removed: { bg: "rgba(13,148,136,0.12)",  fg: "#0D9488" }, // teal
                    filed:   { bg: "rgba(245,158,11,0.12)",  fg: "#F59E0B" }, // amber
                    pending: { bg: "rgba(226,75,74,0.1)",    fg: "#f09595" }, // red
                  };
                  const p = palette[r.status] || palette.pending;
                  return { fontSize: 11, padding: "3px 10px", borderRadius: 20, background: p.bg, color: p.fg, flexShrink: 0, marginLeft: 16 };
                })()}>
                  {r.status || "pending"}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* How it works reminder */}
        <div style={{ ...S.card, marginTop: 32, background: "rgba(13,148,136,0.04)", border: "0.5px solid rgba(13,148,136,0.1)" }}>
          <div style={{ fontSize: 11, fontWeight: 500, color: "#0D9488", letterSpacing: "0.08em", marginBottom: 16 }}>HOW CLEAN SLATE WORKS</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 24 }}>
            {[
              { step: "01", text: "You upload your old content — videos, photos, anything you want removed." },
              { step: "02", text: "We scan the internet every week looking for copies. No username needed." },
              { step: "03", text: "Every copy we find gets a removal request filed. You get a monthly report." },
            ].map((s, i) => (
              <div key={i}>
                <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 32, color: "rgba(13,148,136,0.3)", marginBottom: 10 }}>{s.step}</div>
                <div style={{ fontSize: 13, color: "rgba(240,237,232,0.5)", lineHeight: 1.6 }}>{s.text}</div>
              </div>
            ))}
          </div>
        </div>

      </main>
    </div>
  );
}
